<template>
  <div>
    <div class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-4  gap-8 mt-12 ">
      <b-card
        v-for="(item, index) in reports"
        class="cust-shadow "
        :key="'item-' + index"
        :style="{ border: `1px solid ${item.color}` === 1 }"
      >
        <div
          class="rounded-full w-10 h-10  flex justify-center items-center  "
          :style="{ background: `${item.color}` }"
        >
          <feather-icon
            icon="UsersIcon"
            class="text-white"
            svgClasses="w-4"
          ></feather-icon>
        </div>
        <p class="font-normal text-black font-bold mt-2">{{ item.status }}</p>
      </b-card>
    </div>
    <!-- <div class="chart mt-12">
      <bar-chart
        :height="350"
        ref="barChart"
        :chart-data="redBarChart.chartData"
      >
      </bar-chart>
    </div> -->
  </div>
</template>
<script>
import * as config from "../../sales-report/barChart/Config";
import BarChart from "../../sales-report/barChart/Barchart";
export default {
  data() {
    return {
      reports: [
        {
          id: "1",
          number: "000",
          status: "Recipient wise",
          color: "#5e72e4"
        },
        {
          number: "000",
          status: "Article wise",
          color: "#11cdef"
        },
        {
          number: "000",
          status: " Time Range",
          color: "#2dce89"
        },
        {
          number: "000",
          status: "Static Info",
          color: "#f5365c"
        }
      ],
      redBarChart: {
        chartData: {
          labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Sales",
              data: [25, 20, 30, 22, 17, 29]
            }
          ]
        },
        extraOptions: config.blueChartOptions
      }
    };
  },
  components: {
    BarChart,
    config
  }
};
</script>
